export default {
    LOAD_SERVICE(state, service) {
        state.items = service;
    }
}